
export default {
    Regular: 1,
    Project: 2,
    Fees: 3,
    RevenueBusiness: 4,
    ExpenseBusiness: 5
};
